require('default-passive-events');

import './components/passive-event-listeners.js';
import '../../theme/scripts/components/link-whatsapp.js';
